var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { I18NLink, Translate } from "../I18N";
import { Icon } from "../UI";
import React, { useRef, useState, useCallback } from 'react';
import { useOnClickOutsideElement } from "../utils/useOnClickOutsideElementHook";









export const DropdownMenu = ({ link, position, hideMobileMenu }) => {
  const [showing, setShowing] = useState(false);
  const dropdownRef = useRef(null);
  const onClickOutside = useCallback(() => {
    setShowing(false);
  }, []);

  const toggleShowing = () => {
    setShowing(!showing);
  };

  const hideMenu = () => {
    setShowing(false);
    hideMobileMenu();
  };
  useOnClickOutsideElement(dropdownRef, onClickOutside);

  const menuOptions = () =>
  link.
  get('sublinks').
  map((sublink, index) => {
    const url = (sublink === null || sublink === void 0 ? void 0 : sublink.get('url')) || '/';
    return url.startsWith('http') ? /*#__PURE__*/
    _jsx("li", {}, index, /*#__PURE__*/
    _jsx("a", {
      href: url,
      className: "btn dropdown-item",
      target: "_blank",
      rel: "noreferrer",
      onClick: hideMenu }, void 0, /*#__PURE__*/

    _jsx(Translate, { context: "Menu" }, void 0, sublink === null || sublink === void 0 ? void 0 : sublink.get('title'))
    )
    ) : /*#__PURE__*/

    _jsx("li", {}, index, /*#__PURE__*/
    _jsx(I18NLink, { to: url, className: "btn dropdown-item", onClick: hideMenu }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: "Menu" }, void 0, sublink === null || sublink === void 0 ? void 0 : sublink.get('title'))
    )
    );

  }).
  toArray();

  return /*#__PURE__*/(
    React.createElement("li", { className: "menuNav-item", key: position, ref: dropdownRef }, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: `btn menuNav-btn menuNav-link dropdown-toggle ${showing ? 'expanded' : ''} `,
      id: "navbarDropdownMenuLink",
      onClick: toggleShowing }, void 0, /*#__PURE__*/

    _jsx(Translate, { context: "Menu" }, void 0, link.get('title')), "\xA0 ", /*#__PURE__*/
    _jsx(Icon, { icon: "caret-down" })
    ), /*#__PURE__*/
    _jsx("ul", { className: `dropdown-menu ${showing ? 'expanded' : ''} ` }, void 0, menuOptions())
    ));

};